export enum KeysEnum {
  arkToken = "ark_arenax_token",
  arkTokenExpiresIn = "ark_arenax_token_expires_in",
  aarpAT = "at",
  arkFirstVisitAt = "ark_arenax_first_visit_at",
  arkUserType = "ark_arenax_user_type",
  aiSessionCookie = "ai_session",
  arkAiSessionLocalStorage = "ark_ai_session",
  aarpToken = "access_token",
  idToken = "id_token",
  aarpCookieToken = "acToken",
  aarpCookieIdToken = "acIdToken",
  aarpTokenExpiresIn = "access_token_expires_in",
}

export enum GameState {
  GAME,
  GAME_END,
  GAME_SCORE_SAVED,
  PENDING,
  PREROLL,
  COVER_MEMBER,
  COVER_LOGGED_IN,
  COVER_SKIP_PREROLL,
  REWARD,
  INTERSTITIAL,
  COVER_PREVIEW_MODE
}

export enum FriendPopupType {
  GetInviteAuthorizedUser = "getInviteAuthorizedUser",
  GetInviteNotAuthorizedUser = "getInviteNotAuthorizedUser",
  SendInvite = "sendInvite",
  AcceptConfirmation = "acceptConfirmation",
  RemoveFriend = "removeFriend",
  MaxCounterError = "maxCounterError",
  MaxCounterToSend = "maxCounterToSend",
}


export enum FriendActionState
{
    AcceptConfirmation = 'acceptConfirmation', 
    RemoveFriend = 'removeFriend',
    Pending ='pending',
    SaveChallenge = 'saveChallenge',
}